import * as THREE from 'three'
import Experience from "./Experience.js"

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass.js'
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js'


export default class Renderer {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.camera = this.experience.camera
        this.time = this.experience.time

        // this.debug = this.experience.debug

        //this.postprocessing = {}

        this.setInstance()
        //this.initPostprocessing()

        // this.instance.autoClear = false

        // this.effectController = {
        //     focus: this.distanceToCenter,
        //     aperture: 13,
        //     maxblur: 0.04
        // }
        // this.update()
        // //Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('Postprocess')
        // }
        // if (this.debug.active) {
        //     this.debugFolder.add(this.effectController, 'focus', 0, 30.0, 0.001).onChange(this.matChanger.bind(this))
        //     this.debugFolder.add(this.effectController, 'aperture', 0, 50, 0.1).onChange(this.matChanger.bind(this))
        //     this.debugFolder.add(this.effectController, 'maxblur', 0.0, 1, 0.001).onChange(this.matChanger.bind(this))
        // }
        // this.matChanger()
    }

    // matChanger () {
    //     this.postprocessing.bokeh.uniforms['focus'].value = this.effectController.focus
    //     this.postprocessing.bokeh.uniforms['aperture'].value = this.effectController.aperture * 0.0001
    //     this.postprocessing.bokeh.uniforms['maxblur'].value = this.effectController.maxblur

    // }

    setInstance () {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            // sortObjects: true,
            powerPreference: 'high-performance'
        })
        this.instance.physicallyCorrectLights = true
        this.instance.outputColorSpace = THREE.SRGBColorSpace
        this.instance.toneMapping = THREE.ACESFilmicToneMapping
        this.instance.toneMappingExposure = 3
        this.instance.shadowMap.enabled = true
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)

    }

    // initPostprocessing () {
    //     // Render target
    //     this.renderTarger = new THREE.WebGLRenderTarget(
    //         800,
    //         600,
    //         {
    //             samples: this.instance.getPixelRatio() === 1 ? 2 : 0

    //         }

    //     )
    //     // Effect composer
    //     this.composer = new EffectComposer(this.instance, this.renderTarger)

    //     // Render pass
    //     this.renderPass = new RenderPass(this.scene, this.camera.instance)


    //     // this.bokehPass = new BokehPass(this.scene, this.camera.instance, {
    //     //     focus: this.distanceToCenter,
    //     //     aperture: 0.025,
    //     //     maxblur: 0.01,

    //     //     width: this.sizes.width,
    //     //     height: this.sizes.height
    //     // })

    //     // if (this.instance.getPixelRatio() === 1 && !this.instance.capabilities.isWebGL2) {
    //     //     this.smaaPass = new SMAAPass()
    //     //     this.composer.addPass(this.smaaPass)
    //     // }

    //     //this.smaaPass = new SMAAPass(this.sizes.width * this.instance.getPixelRatio(), this.sizes.height * this.instance.getPixelRatio())
    //     this.smaaPass = new SMAAPass()

    //     //this.smaaPass.renderToScreen = true

    //     this.composer.addPass(this.smaaPass)

    //     //this.composer.addPass(this.bokehPass)
    //     this.composer.addPass(this.renderPass)


    //     this.postprocessing.composer = this.composer
    //     this.postprocessing.bokeh = this.bokehPass

    // }

    resize () {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)

        //this.postprocessing.composer.setSize(this.sizes.width, this.sizes.height)

    }

    update () {
        this.instance.render(this.scene, this.camera.instance)

        // this.distanceToCenter = this.camera.instance.position.distanceTo(this.scene.position)
        // this.postprocessing.bokeh.uniforms['focus'].value = this.distanceToCenter
        // this.effectController['focus'] = this.distanceToCenter
        //this.postprocessing.composer.render(this.time.delta)
    }
}